module.exports = "/_next/static/images/Hero@2x-629a9813cd8ad10ccc7c9c586d701725.webp";